import styled from 'styled-components'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

const tabletQuery = createResponsiveBreakpointQuery('tabletUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.tabletUp
})

export const LoginWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.neutralW10};
  height: 100vh;
  display: grid;
  grid-template-rows: 1fr 12fr 0.5fr;
  overflow-y: auto;
`
export const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media ${tabletQuery} {
    padding-top: 16px;
    justify-content: flex-start;
  }
`
export const LoginFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow-y: hidden;
  background-color: ${({ theme }) => theme.colors.neutralW10};
`
export const Link = styled.a`
  color: ${({ theme }) => theme.colors.neutralW70};
  font-size: 14px;
  font-weight: 400;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 20px;
  padding-top: 20px;
`
export const LoginCardContainer = styled.div`
  display: flex;
  width: 90vw;
  position: relative;
  border-top: 4px;
  border-radius: 5px;
  border-top: ${({ theme }) => `4px solid ${theme.colors.player50}`};
  background-color: ${({ theme }) => theme.colors.neutralW20};
  max-width: 676px;
`

export const FooterText = styled.div`
  display: flex;
  font-size: 14px;
  cursor: pointer;
  padding-top: 24px;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.interact70};
`

export const FooterLink = styled.div`
  display: flex;
  font-size: 14px;
  cursor: pointer;
  padding-top: 24px;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.neutral70};
`
